<template>
    <div id="sites">
        <section class="welcome">
            <div class="start">
                <h1>
                    <span>Наши сайты</span>
                </h1>
                <div class="text">В виртуальном пространстве Интернета Группа компаний &laquo;Ренна&raquo;&nbsp; представлена своими информационными ресурсами.
                Среди них порталы производственных площадок и структурных подразделений Группы, сайты торговых марок и&nbsp;страницы инновационных
                продуктов. Наши покупатели также активно пользуются Форумами и&nbsp;обсуждениями по&nbsp;общим интересам, развернутыми на&nbsp;страницах известных
                социальных сетей.
                </div>
                <div class="text">
                Все виды информационных ресурсов обеспечены на высшем технологическом уровне. Их работа
                поддерживается собственным вычислительным центром и техническими средствами наших партнеров.
                </div>
            </div>
        </section>


        <section class="proizvodstvo">

            <div class="title">Производственные площадки ГК&nbsp;&laquo;Ренна&raquo;</div>
            
            <div class = "kmkk" onclick="location.href='https://kmkk.ru';"> 
                <div class="link"><a href="https://kmkk.ru">Кореновский молочно-консервный комбинат (https://kmkk.ru)</a></div>
                <div class="text">Официальный сайт Кореновского молочно-консервного комбината&nbsp– одного из&nbsp;крупнейших производственных предприятий
                Краснодарского края. Почти 70&nbsp;лет на&nbsp;комбинате выпускается натуральная молочная продукция, которая поставляется во&nbsp;все регионы
                России, а&nbsp;также страны ближнего и&nbsp;дальнего зарубежья. Именно здесь производится продукция бренда &laquo;Коровка из&nbsp;Кореновки&raquo;.
                </div>
            </div>

            <div class = "amkk" onclick="location.href='https://amkk.ru';">
                <div class="link"><a href="https://amkk.ru">Алексеевский молочноконсервный комбинат (https://amkk.ru)</a></div>
                <div class="text">Официальный сайт Алексеевского молочноконсервного комбината&nbsp;– российского лидера по&nbsp;объемам производства молочных
                консервов. Более 60&nbsp;лет комбинат высоко держит планку: сгущенное молоко ТМ&nbsp;&laquo;Алексеевское&raquo; любимо покупателями всей страны 
                за&nbsp;качество и&nbsp;отменный вкус.
                </div>
            </div>

        </section>

        <section class="divisions">

            <div class="title">Структурные подразделения ГК&nbsp;&laquo;Ренна&raquo;</div>

            <div class ="logist" onclick="location.href='https://logistics.rennagroup.ru';">
                <div class="link"><a href="https://logistics.rennagroup.ru">&laquo;Ренна-Логистик&raquo; (https://logistics.rennagroup.ru)</a></div>
                <div class="text">Cайт компании &laquo;Ренна-Логистик&raquo;. Компания предлагает широкий спектр услуг по&nbsp;доставке грузов по&nbsp;всей
                территории страны, а&nbsp;также по&nbsp;их&nbsp;сопровождению и&nbsp;хранению. Для удобства работы с&nbsp;партнерами и&nbsp;перевозчиками
                 на&nbsp;сайт &laquo;Ренна-Логистик&raquo; подгружены все необходимые комплекты документов.
                </div>
            </div>

            <div class ="distrib" onclick="location.href='https://distribution.rennagroup.ru';">
                <div class="link"><a href="https://distribution.rennagroup.ru">&laquo;Ренна-Дистрибуция&raquo; (https://distribution.rennagroup.ru)</a></div>
                <div class="text">Cайт компании &laquo;Ренна-Дистрибуция&raquo;. Интернет-площадка собственной сети дистрибуторских компаний
                &mdash;&nbsp;&laquo;Лидеров&raquo;. Портал &laquo;Ренна-Дистрибуция&raquo; содержит обширную библиотеку знаний: каталоги продукции и&nbsp;
                презентации, декларации соответствия и&nbsp;posm-материалы.
                </div>
            </div>

            <div class ="export" onclick="location.href='https://export.rennagroup.ru';">
                <div class="link"><a href="https://export.rennagroup.ru">&laquo;Ренна-Экспорт&raquo; (https://export.rennagroup.ru)</a></div>
                <div class="text"> Сайт &laquo;Ренна-Экспорт&raquo; доступен на&nbsp;русском и&nbsp;английском языках. Здесь размещены удобные каталоги товаров и&nbsp;брендов,
                поставляемых за&nbspрубеж, включая продукцию для сектора b2b.
                </div>
            </div>

        </section>

        <section class = "brends">

            <div class="title">Сайты ключевых брендов ГК&nbsp;&laquo;Ренна&raquo;</div>

            <div class="kizk" onclick="location.href='https://kizk.ru';">
                <div class="link"><a href="https://kizk.ru">&laquo;Коровка из&nbsp;Кореновки&raquo; (https://kizk.ru)</a></div>
                <div class="text"> Официальный сайт бренда &laquo;Коровка из&nbsp;Кореновки&raquo;. Здесь вы сможете прочесть последние новости из&nbsp;жизни бренда,
                ознакомиться с&nbsp;полным каталогом продукции, а&nbsp;также узнать новые кулинарные решения от&nbsp;популярных блогеров и&nbsp;фудфотографов.
                </div>
            </div>

            <div class="alex" onclick="location.href='https://alekseevskoe.com';">
                <div class="link"><a href="https://alekseevskoe.com">&laquo;Алексеевское&raquo; (https://alekseevskoe.com)</a></div>
                <div class="text"> Официальный сайт бренда &laquo;Алексеевское&raquo;. Узнайте больше новостей и&nbsp;интересных фактов об&nbsp;истории сгущенного
                молока! Познакомьтесь с&nbsp;процессом производства продукции от&nbsp;приемки сырья до&nbsp;размещения готового товара на&nbsp;полках магазинов.
                Раздел с&nbsp;актуальными рецептами блюд пополняется регулярно.
				<!--ежемесячно-->
                </div>
            </div>
        </section>
<!--
        <section class = "marketplace">
            <div class="title">Интернет-торговля</div>

            <div class ="shop" onclick="location.href='https://korenovka.ru';">
                <div class="link"><a href="https://korenovka.ru">Интернет-магазин &laquo;Кореновка.RU&raquo; (https://korenovka.ru)</a></div>
                <div class="text"> Интернет-магазин &laquo;Кореновка.RU&raquo; предлагает вам большой выбор самых вкусных и&nbsp;натуральных молочных продуктов
                и&nbsp;мороженого от&nbsp;любимых брендов собственного производства &mdash; &laquo;Коровка из&nbsp;Кореновки&raquo;, &laquo;Алексеевское&raquo;,
                &laquo;Облака из&nbsp;Молока&raquo;. Интернет-магазин работает в&nbsp;Москве и&nbsp;Московской области.
                </div>
            </div>
        </section>
-->
        <section class = "more">
            
            <div class="title">Узнайте больше о&nbsp;наших новинках!</div>

            <div class = "serd" onclick="location.href='https://serdechnoe.ru';">
                <div class="link"><a href="https://serdechnoe.ru">Сердечное мороженое (https://serdechnoe.ru)</a></div>
                <div class="text">Сердечное мороженое для душевных вечеров.</div>
            </div>

            <div class ="choko" onclick="location.href='https://chokoboom.com';">
                <div class="link"><a href="https://chokoboom.com">Мягкий шоколад (https://chokoboom.com)</a></div>
                <div class="text">Мягкий молочный шоколад &laquo;Коровка из&nbsp;Кореновки&raquo; без&nbsp;пальмового масла.</div>
            </div>

            <div class ="molonez" onclick="location.href='http://molonez.ru';">
                <div class="link"><a href="http://molonez.ru">Молонез (http://molonez.ru)</a></div>
                <div class="text">Молонез: вкус майонеза, польза молока.</div>
            </div>
        </section>

<!--                
        <div class="lenta">

            <news></news>

            <!--<div class="lenta-logo"></div>-->
        </div>
-->

    </div>
</template>

<script>
    export default {
        name: "Sites"
    }
</script>